export enum AuthBackends {
  CONNECT = 'CONNECT',
  PRUSA_AUTH = 'PRUSA_AUTH'
}
